import Paper from "@material-ui/core/esm/Paper";
import Box from "@material-ui/core/esm/Box";
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import Add from "@material-ui/icons/esm/Add";
import PersonAdd from "@material-ui/icons/esm/PersonAdd";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useRecoilValueLoadable } from 'recoil';
import { CustomerType } from 'api';
import { getCustomers } from 'api/customers/getCustomers';
import { Header, LargeHeader, Subtitle, BoldSubtitle } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import { CREATE_CUSTOMER } from 'routes/customers/paths';
import { HOME } from 'routes/home/paths';
import checkLoadable from 'utils/recoil/checkLoadable';
import ActivateAccessDialog from './ActivateAccessDialog/ActivateAccessDialog';
import CustomerCards from './CustomersCards/CustomerCards';
import useStyles from './CustomersStyle';
export default function Customers() {
  const {
    t
  } = useTranslation();
  const {
    customersRoot,
    icon,
    box,
    chevron
  } = useStyles();
  const {
    push
  } = useHistory();
  const {
    setCustomer
  } = useCurrentCustomer();
  const [isActivateAccessDialogOpen, setIsActivateAccessDialogOpen] = useState(false);
  const customersLoadable = useRecoilValueLoadable(getCustomers);
  const {
    contents: customers,
    loading
  } = checkLoadable(customersLoadable);
  const redirectToHome = customer => {
    setCustomer(customer);
    sessionStorage.setItem('customer-redirected', 'true');
    push(HOME);
  };
  const peopleCustomers = customers?.filter(customer => customer.customerType === CustomerType.Person);
  const companyCustomers = customers?.filter(customer => customer.customerType === CustomerType.Company);
  if (customers?.length === 1) {
    const customer = customers ? customers[0] : undefined;
    const alreadyRedirected = sessionStorage.getItem('customer-redirected') === 'true';
    if (customer && !alreadyRedirected) {
      redirectToHome(customer);
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LargeHeader, null, t('customers.customers')), /*#__PURE__*/React.createElement(Header, null, t('titles.create_new_customer')), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: customersRoot,
    onClick: () => push(CREATE_CUSTOMER)
  }, /*#__PURE__*/React.createElement(Add, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h3",
    align: "left"
  }, t('customers.create_customer')), /*#__PURE__*/React.createElement(Subtitle, {
    component: "h3"
  }, t('customers.new_customer_description'))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })), /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: customersRoot,
    onClick: () => setIsActivateAccessDialogOpen(true)
  }, /*#__PURE__*/React.createElement(PersonAdd, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    component: "h3",
    align: "left"
  }, t('customers.activate_access')), /*#__PURE__*/React.createElement(Subtitle, {
    component: "h3"
  }, t('customers.activate_access_desc'))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })), /*#__PURE__*/React.createElement(Header, null, t('titles.choose_customers')), /*#__PURE__*/React.createElement(CustomerCards, {
    customers: peopleCustomers ?? [],
    loading: loading,
    redirectToCustomer: redirectToHome
  }), /*#__PURE__*/React.createElement(Box, {
    mt: 2
  }, /*#__PURE__*/React.createElement(CustomerCards, {
    customers: companyCustomers ?? [],
    loading: loading,
    redirectToCustomer: redirectToHome,
    isCompany: true
  })), /*#__PURE__*/React.createElement(ActivateAccessDialog, {
    open: isActivateAccessDialogOpen,
    onClose: () => setIsActivateAccessDialogOpen(false)
  }));
}